
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100","height":"100","viewBox":"0 0 100 100","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M89.311 48.107L79.9 38.694a2.358 2.358 0 00-3.33 0 2.358 2.358 0 000 3.33l5.395 5.394-63.928-.006 5.394-5.394a2.358 2.358 0 000-3.33 2.358 2.358 0 00-3.33 0l-9.412 9.413a2.356 2.356 0 000 3.33l9.413 9.412a2.352 2.352 0 001.665.688 2.352 2.352 0 001.665-4.018l-5.395-5.394H81.97l-5.395 5.394a2.358 2.358 0 000 3.33 2.352 2.352 0 003.324 0l9.413-9.412A2.356 2.356 0 0090 49.766c0-.624-.247-1.224-.688-1.66z"}})])
          )
        }
      }
    